// extracted by mini-css-extract-plugin
export default {"content":"style_content__pNNim","container":"style_container__WIbVp"};